<template>
    <div class="search-bar">
        <div class="d-flex align-items-center">
            <label class="mr-sm-2 mb-0">Pencarian</label>
            <form class="form-inline d-flex flex-wrap">
                <div class="form-group mb-0">
                    <input type="text" style="min-width: 200px;" v-model="searchText" class="form-control" @keyup.enter="doSearch"
                        placeholder="admin, sopir, vendor..." data-lpignore="true">
                </div>
                <div class="form-group mb-0">
                    <date-picker v-model="searchDate" range type="date" placeholder="Tanggal Keluar" :editable="false" format="DD-MM-YYYY"></date-picker>
                </div>
                <div class="form-group mb-0">
                    <multiselect v-model="searchType" :options="typeOptions" :placeholder="'Pilih tipe'" :searchable="true"
                        label="label" track-by="value" :show-labels="false"></multiselect>
                </div>
                <div class="form-group mb-0">
                    <button class="btn btn-primary" @click.prevent="doSearch">Cari</button>
                    <button class="btn btn-light" @click.prevent="resetSearch">Reset</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';

export default {
    components: {
        Multiselect,
        DatePicker,
    },

    data() {
        return {
            searchText: '',
            searchDate: '',
            searchType: {
                value: 'pindah_gudang',
                label: 'Pindah Gudang',
            },
            typeOptions: [
                {
                    value: 'pindah_gudang',
                    label: 'Pindah Gudang',
                },
                {
                    value: 're_dry',
                    label: 'Re Dry',
                },
            ],
        }
    },

    methods: {
        doSearch() {
            let self = this,
                data = {
                    searchText: self.searchText,
                    searchDate: self.searchDate[0] && self.searchDate[1] ? self.searchDate : null,
                    searchType: self.searchType ? self.searchType.value : '',
                };
            self.$emit('search-set', data);
        },

        resetSearch() {
            this.searchText = '';
            this.searchDate = '';
            this.searchType = {
                value: 'pindah_gudang',
                label: 'Pindah Gudang',
            };
            this.$emit('search-reset');
        },
    }
}
</script>
<style>
.search-bar {
    padding: 10px;
}
</style>
